import { render, staticRenderFns } from "./SendTitleReassignmentDocument.vue?vue&type=template&id=53328128&scoped=true"
import script from "./SendTitleReassignmentDocument.vue?vue&type=script&lang=js"
export * from "./SendTitleReassignmentDocument.vue?vue&type=script&lang=js"
import "./SendTitleReassignmentDocument.vue?vue&type=style&index=0&id=53328128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53328128",
  null
  
)

export default component.exports